<app-dialog [show]="show" type="clear" [close]="true" (toggle)="onClose()">
  <div class="w-full flex flex-col" *ngIf="notification">
    <!-- Title -->
    <div *ngIf="displayTitle" class="font-bold text-[14px] mb-2" [innerHTML]="displayTitle"></div>

    <!-- Date/Time (optional, only provided by mobile) -->
    <div *ngIf="dateTimeLabel" class="flex justify-center mb-3">
      <ion-label class="text-[10px] font-bold text-center">{{ dateTimeLabel }}</ion-label>
    </div>

    <!-- Body: type 5/6 renders HTML -->
    <div *ngIf="notificationType === 5 || notificationType === 6"
      class="text-sm mt-2 whitespace-pre-line"
      [innerHTML]="bodyHtml"></div>
    <!-- Body: other types render plain text -->
    <div *ngIf="notificationType !== 5 && notificationType !== 6"
      class="text-sm mt-2 whitespace-pre-line">{{ plainBody }}</div>

    <!-- Action buttons -->
    <div *ngIf="hasActions" class="mt-4 flex flex-row justify-evenly items-center gap-3 w-full">
      <!-- Route-based access -->
      <ion-button *ngIf="selectedRoute && notificationType !== 6" class="flex-1" expand="block" size="small" color="primary"
        (click)="$event.stopPropagation(); onAccessRoute($event)">
        {{ 'NOTIFICATIONS.ACCESS' | translate }}
      </ion-button>
      <!-- Type 5: contact / go to conversation -->
      <ion-button *ngIf="notificationType === 5" class="flex-1" expand="block" size="small" color="primary"
        (click)="$event.stopPropagation(); onStartContact($event)">
        {{ 'NOTIFICATIONS.GO_TO_CONVERSATION' | translate }}
      </ion-button>
      <!-- Type 4/6: chat navigation -->
      <ion-button *ngIf="(notificationType === 4 || notificationType === 6) && canOpenConversation"
        class="flex-1" expand="block" size="small"
        (click)="onNavigateChat($event)">
        {{ actionKey | translate }}
      </ion-button>
    </div>

    <!-- ═══ Accept Proposal: finder responds to owner's first free message ═══ -->
    <div *ngIf="isProposal" class="mt-4 w-full">
      <div class="proposal-collapsible-section">
        <button class="proposal-collapsible-header" (click)="toggleAcceptProposal()" type="button">
          <span class="proposal-collapsible-label">
            {{ 'NOTIFICATIONS.ACCEPT_PROPOSAL' | translate }}
          </span>
          <ion-icon [name]="acceptProposalOpen ? 'chevron-up' : 'chevron-down'" class="proposal-collapsible-icon"></ion-icon>
        </button>

        <div class="proposal-collapsible-body" [class.open]="acceptProposalOpen">
          <div class="proposal-collapsible-body-inner">
            <ng-container *ngIf="!hasStoredProposalResponse; else proposalAlreadySent">
              <div class="proposal-textarea-wrapper">
                <input type="text" class="proposal-response-input" [(ngModel)]="proposalResponse"
                  [maxlength]="MAX_PROPOSAL_RESPONSE_LENGTH"
                  [placeholder]="'NOTIFICATIONS.RESPONSE_PLACEHOLDER' | translate" />
                <span class="proposal-char-counter">{{ proposalResponse.length }}/{{ MAX_PROPOSAL_RESPONSE_LENGTH }}</span>
              </div>

              <p class="proposal-security-warning">
                {{ 'NOTIFICATIONS.SECURITY_WARNING' | translate }}
              </p>
              <p class="proposal-free-channel-info" [innerHTML]="'NOTIFICATIONS.FREE_CHANNEL_INFO' | translate"></p>

              <div class="flex justify-end w-full">
                <ion-button color="secondary" class="proposal-send-button"
                  [disabled]="sendingProposal" (click)="$event.stopPropagation(); onSendProposal()">
                  <ion-spinner *ngIf="sendingProposal" name="crescent" slot="start"></ion-spinner>
                  {{ 'NOTIFICATIONS.SEND' | translate }}
                  <ion-icon name="chevron-forward" slot="end"></ion-icon>
                </ion-button>
              </div>
            </ng-container>

            <ng-template #proposalAlreadySent>
              <p class="proposal-security-warning">
                {{ 'NOTIFICATIONS.MESSAGE_SENT_LABEL' | translate }}
              </p>
              <div class="proposal-sent-message-card">
                <p class="proposal-sent-message-text">{{ storedProposalResponse }}</p>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-dialog>
